'use client';

import { useRouter } from 'next/navigation';
import { useEffect, useRef } from 'react';
import OneSignal, { NotificationClickEvent } from 'react-onesignal';
import { captureException } from '@sentry/nextjs';
import { appConfig } from '@/config/app';
export const OneSignalInitialize = () => {
  const router = useRouter();
  const initialized = useRef(false);
  const initOneSignal = async () => {
    if (!appConfig.oneSignal?.appId || initialized.current) return;
    const promptOptions: PromptOptionsCustom = {
      slidedown: {
        prompts: [{
          type: 'push',
          autoPrompt: true,
          text: {
            actionMessage: 'Receba gratuitamente no seu navegador alertas e oportunidades de investimento. Saia quando quiser.',
            acceptButton: 'Entrar',
            cancelButton: 'Não, obrigado'
          },
          delay: {
            pageViews: 1,
            timeDelay: 0
          },
          categories: []
        }]
      }
    };
    try {
      await OneSignal.init({
        appId: appConfig.oneSignal?.appId,
        safari_web_id: appConfig.oneSignal?.safariWebId,
        promptOptions: promptOptions,
        allowLocalhostAsSecureOrigin: process.env.NODE_ENV === 'development'
      });
      OneSignal.Slidedown.promptPush();
      OneSignal.Notifications.addEventListener('click', onClicknotification);
    } catch (error) {
      captureException({
        tag: 'libs.onesignal',
        error,
        message: `Erro ao inicializar OneSignal`
      });
    }
  };
  useEffect(() => {
    if (typeof window === 'undefined' || !appConfig.oneSignal?.appId) return;
    if (!initialized.current) {
      console.log('Initializing OneSignal...');
      initOneSignal();
      initialized.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const onClicknotification = (event: NotificationClickEvent) => {
    const launchURL = event.notification.launchURL;
    if (launchURL?.includes(appConfig?.scheme)) {
      router.push(getUrlByLaunchURLPush(launchURL));
    } else if (launchURL) {
      router.push(launchURL);
    }
  };
  return null;
};
interface PromptOptionsCustom {
  slidedown: {
    prompts: Array<{
      type: 'push' | 'sms' | 'email';
      autoPrompt: boolean;
      text: {
        actionMessage?: string;
        acceptButton?: string;
        cancelButton?: string;
      };
      delay: {
        pageViews?: number;
        timeDelay?: number;
      };
      categories: Array<{
        tag: string;
        label: string;
      }>;
    }>;
  };
}
const getUrlByLaunchURLPush = (launchURL: string) => {
  if (!launchURL.includes(appConfig?.scheme)) return launchURL;
  const path = launchURL.replace(appConfig?.scheme, '');
  return `/${path}`;
};